import React, { useContext, useState } from "react";
import verified from "../../images/verified.png";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";

export default function ProjectExpertIsVerified({
  email,
  isVerified,
  setIsVerified,
  expert_id,
  backupData,
  setBackupData,
}) {
  const [isVerifiedPopup, setIsVerifiedPopup] = useState(false);
  const [noEmailPopup, setNoEmailPopup] = useState(false);
  const { API_URL } = useContext(UrlContext);

  const handleIsVerified = () => {
    if(email !== 'email@email.com' || isVerified){
      const url = `${API_URL}save-expert-verified`;
      const data = {
        expertID: expert_id,
        isVerified: !isVerified,
      };
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setIsVerifiedPopup(false);
            setIsVerified(!isVerified);
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            setBackupData(
              backupData.map((item) => {
                if (item.expert.ID === expert_id) {
                  item.expert.verified = !isVerified;
                }
                return item;
              })
            );
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
          }
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });

    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No email for the profile. Please add the email first!",
      });
    }
  };

  return (
    <>
      {isVerified ? (
        <>
          <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: "-5px"}} >
            <i class="fa-solid fa-certificate" style={{color: "#365561", cursor: "pointer"}} onClick={() => setIsVerifiedPopup(true)}></i>
            <i class="fa-solid fa-check" style={{color: "white", fontSize: "10px", position: "absolute", cursor: "pointer"}} onClick={() => setIsVerifiedPopup(true)}></i>
          </div>
        </>
      ) : (
        <>
          <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: "-5px"}} >
            <i class="fa-solid fa-certificate" style={{color: "lightgrey", cursor: "pointer"}} onClick={() => handleIsVerified()}></i>
            <i class="fa-solid fa-check" style={{color: "white", fontSize: "10px", position: "absolute", cursor: "pointer"}} onClick={() => handleIsVerified()}></i>
          </div>
        </>
      )}

      {isVerifiedPopup && (
        <div className="prjdetails-removeVIP-popup-wrapper">
          <div className="tab-pane fade show prjdetails-removeVIP-div">
            <div>
              <center>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", fontSize: "30px"}} >
                  <i class="fa-solid fa-certificate" style={{color: "#365561", cursor: "pointer"}}></i>
                  <i class="fa-solid fa-check" style={{color: "white", fontSize: "15px", position: "absolute", cursor: "pointer"}}></i>
                </div>
                <p style={{color: "#365561", marginTop: "20px"}}>
                  Remove this expert from <strong>Verified</strong> list?
                </p>
                <br />
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn btn-light"
                  onClick={() => setIsVerifiedPopup(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: "6px" }}
                  onClick={() => handleIsVerified()}
                >
                  Continue
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
